export const getFieldRule = (fieldName, config) => {
  return config?.fieldRules?.[fieldName] || {};
};

export const isFieldDisabled = (fieldName, row, config = {}) => {
  const rules = config?.fieldRules || {};

  const key = Object.keys(rules).find(
    (k) => k.toLowerCase() === fieldName?.toLowerCase(),
  );

  const rule = rules?.[key];

  if (!rule) return false;

  if (typeof rule.disabled === "function") {
    return rule.disabled(row);
  }

  return !!rule.disabled;
};

export const isFieldRequired = (fieldName, config = {}) => {
  const rules = config?.fieldRules || {};

  const key = Object.keys(rules).find(
    (k) => k.toLowerCase() === fieldName?.toLowerCase(),
  );

  return rules?.[key]?.required || false;
};

// export const isFieldReadOnly = (fieldName, config = {}) => {
//   return Boolean(getFieldRule(fieldName, config).readOnly);
// };
export const isFieldReadOnly = (fieldName, config = {}) => {
  const rules = config?.fieldRules || {};

  const key = Object.keys(rules).find(
    (k) => k.toLowerCase() === fieldName?.toLowerCase(),
  );

  return !!rules?.[key]?.readOnly;
};
